// import { useRouter } from "next/router";
import { useTranslations as nextUseTranslations } from "next-intl";

// export function useTranslation(namespace?: keyof IntlMessages = "strings") {
export function useTranslation() {
  // @ts-ignore
  return nextUseTranslations("strings");
}
